import React from 'react'
import type { ReactElement, ChangeEvent } from 'react'
import { BasketItemModel } from './types/models'
import { formatPriceString } from '../../common/helpers/number-formatters'

type BasketHireWeeksProps = {
  item: BasketItemModel;
  onHireWeeksChanged: (id: number, hirePriceId: string) => void;
}

const BasketHireWeeks = ({ item, onHireWeeksChanged }: BasketHireWeeksProps): ReactElement => (
  <select
    name="SelectList"
    className="basket-hireSelect"
    value={item.hire_price_id}
    onChange={
      (event: ChangeEvent<HTMLSelectElement>): void => {
        onHireWeeksChanged(item.id, event.target.value)
      }
    }
  >
  {item.hire_prices.map((hPInfo, key) => {
    const message = `${hPInfo[1]} weeks ${formatPriceString(hPInfo[2])}/week`
    return (
    <option key={key} value={hPInfo[0]}>{message}</option>
    )
  })}
  </select>
)
export default BasketHireWeeks
